export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.factory-247.com/v1';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  QR_LOGIN: '/qr-login',
  SCHEDULE: '/schedule',
  EQUIPMENT: '/equipment',
  PRODUCTS: '/products',
  METRICS: '/metrics',
  ADMIN_USERS: '/admin/users',
  ADMIN_CONFIG: '/admin/config',
  ADMIN_STAFF_SCHEDULE: '/admin/staff-schedule',
  ADMIN_OVEN_PROGRAMS: '/admin/oven-programs',
} as const;

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  WORKER: 'worker',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 100,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
} as const;

export const PROTEIN_COLORS: Record<string, [number, number, number]> = {
  'BEEF':         [165,   0,  38],
  'PORK':         [215,  48,  39],
  'LAMB':         [244, 109,  67],
  'DUCK':         [253, 174,  97],
  'TURKEY':       [254, 224, 144],
  'CHICKEN':      [224, 243, 248],
  'SALMON':       [171, 217, 233],
  'COD':          [116, 173, 209],
  'SWEET POTATO': [ 69, 117, 180],
  // Purple — must NOT read as green: unmatched proteins fall back to a
  // translucent chip that blends into the lot's green fill ("PIG EARS" bug).
  'PIG':          [123,  50, 148],
};

// Width in pixels of one oven column slot — used in schedule grid, lane layout, and RecipeBlock
export const SLOT_WIDTH = 80;

// Minutes of the fixed COOL DOWN box that follows RELEASE, before the yellow
// WAITING TO UNLOAD box starts. Client-defined; may become configurable later.
export const COOL_DOWN_MINUTES = 30;

// A yellow box (WAITING TO UNLOAD and striped READY TO LOAD) is HIDDEN while its
// span is this many minutes or less — a short wait/idle isn't worth flagging and
// only clutters the board. Once the span EXCEEDS this, the box appears at its
// FULL height from its natural anchor (cool-down end for WAITING, unloadedAt for
// READY) — no blank gap and no thin sliver; it pops in already this many minutes
// tall, then keeps growing to the red line.
// A useful side effect for READY: if the next lot loads within this window (e.g.
// DONE was clicked late, after the next group already started), the ready span is
// <= this threshold, so the box never appears.
export const YELLOW_BOX_MIN_MINUTES = 10;

export const SCHEDULE_CONFIG = {
  START_HOUR: 0,
  START_MINUTE: 0,
  END_HOUR: 24,
  END_MINUTE: 0,
  INTERVAL_MINUTES: 10,
  ALTERNATE_ROW_COUNT: 3, // Number of rows before alternating color
  DAYS_TO_SHOW: 7,        // Number of days to show in continuous scroll
} as const;
